import { combineReducers } from 'redux';

import dialogSendPayment from './dialogDetailsSlips';

const reducer = combineReducers({
  [dialogSendPayment.name]: dialogSendPayment.reducer,
});

export default reducer;
